import { Check, FileCheck2, ArrowUpRight, ScanLine, BarChart3 } from 'lucide-react';
import { Typography } from './Typography';
import styles from './DataVisual.module.css';
export function DataVisual({
  kind = 'report',
}: {
  kind?: 'report' | 'inventory' | 'analysis' | 'assets';
}) {
  if (kind === 'inventory')
    return (
      <div className={`${styles.visual} ${styles.inventory}`} aria-label="Иллюстрация сверки учёта">
        <div className={styles.table}>
          <div className={styles.tableHeader}>
            {['Объект', 'Проверка', 'Статус'].map((x) => (
              <Typography key={x} as="span" variant="diagramLabel" tone="muted">
                {x}
              </Typography>
            ))}
          </div>
          {[
            'Складские запасы',
            'Оборудование',
            'Материалы',
            'Основные средства',
            'Производственные активы',
          ].map((x, i) => (
            <div className={styles.tableRow} key={x}>
              <Typography as="span" variant="diagram">
                {x}
              </Typography>
              <Typography as="span" variant="diagram" tone="muted">
                {String(i + 1).padStart(2, '0')}
              </Typography>
              <span className={styles.status}>
                <Check size={12} aria-hidden />
                <Typography as="span" variant="diagram" tone="inherit">
                  Сверено
                </Typography>
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  if (kind === 'analysis')
    return (
      <div
        className={`${styles.visual} ${styles.analysis}`}
        aria-label="Иллюстрация аналитического отчёта"
      >
        <div className={styles.chart}>
          <div className={styles.chartTop}>
            <Typography variant="caption" tone="muted">
              От данных к решениям
            </Typography>
            <BarChart3 size={18} aria-hidden />
          </div>
          <div className={styles.bars}>
            {[45, 60, 39, 78, 65, 90, 80].map((n, i) => (
              <div className={styles.bar} key={i} data-height={n} />
            ))}
          </div>
          <div className={styles.chartBottom}>
            <Typography variant="diagram" tone="muted">
              Проверка
            </Typography>
            <Typography variant="diagram" tone="muted">
              Анализ
            </Typography>
            <Typography variant="diagram" tone="muted">
              Результат
            </Typography>
          </div>
        </div>
      </div>
    );
  if (kind === 'assets')
    return (
      <div className={`${styles.visual} ${styles.assets}`}>
        <div className={styles.asset}>
          <ScanLine size={44} strokeWidth={1} aria-hidden />
          <Typography variant="intro">Каждый актив учтён</Typography>
          <div className={styles.assetRows}>
            {['Наличие', 'Состояние', 'Учётная стоимость'].map((x) => (
              <div key={x}>
                <Typography as="span" variant="diagramLabel" tone="muted">
                  {x}
                </Typography>
                <Check size={16} aria-hidden />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  return (
    <div
      className={`${styles.visual} ${styles.report}`}
      aria-label="Иллюстрация финансового отчёта"
    >
      <div className={styles.reportCard}>
        <div className={styles.chartTop}>
          <Typography variant="diagramLabel">Достоверность данных</Typography>
          <FileCheck2 size={18} aria-hidden />
        </div>
        <div className={styles.reportBody}>
          <div>
            <Typography variant="compactMetric">МСФО</Typography>
            <div className={styles.legend}>
              <Typography variant="diagram" tone="muted">
                Отчётность
              </Typography>
              <Typography variant="diagram" tone="muted">
                Проверка
              </Typography>
              <Typography variant="diagram" tone="muted">
                Заключение
              </Typography>
            </div>
          </div>
          <div className={styles.donut}>
            <ArrowUpRight size={30} strokeWidth={1} aria-hidden />
          </div>
        </div>
      </div>
    </div>
  );
}
